export const selectUser = (store) => store.apps.jobs.users.get('user');
